import React, { useEffect, useState } from "react";
import { createAttachmentObjectUrl, getAttachmentName } from "../../helpers/attachmentUtils";

export default function ImageAttachmentPreview({ file }) {
  const [previewUrl, setPreviewUrl] = useState(null);

  useEffect(() => {
    let active = true;
    let shouldRevoke = false;
    let objectUrl = null;

    createAttachmentObjectUrl(file).then(({ url, revoke }) => {
      if (!active) {
        if (revoke && url) URL.revokeObjectURL(url);
        return;
      }

      objectUrl = url;
      shouldRevoke = revoke;
      setPreviewUrl(url);
    });

    return () => {
      active = false;
      if (shouldRevoke && objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [file]);

  if (!previewUrl) return null;

  return (
    <a href={previewUrl} target="_blank" rel="noopener noreferrer" style={{ display: "block", width: "fit-content" }}>
      <img
        src={previewUrl}
        alt={getAttachmentName(file, "Image attachment")}
        style={{
          display: "block",
          maxWidth: 240,
          maxHeight: 180,
          objectFit: "cover",
          borderRadius: 8,
          marginBottom: 8,
        }}
      />
    </a>
  );
}
